var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/encoder.ts
import { encode as encodeToBase58 } from "@urlpack/base58";
import { makeMessagePackEncoder } from "@urlpack/msgpack";
function makeJsonEncoder(options = {}) {
  const encodeData = options.encodeData || makeMessagePackEncoder().encode;
  const encodeBinary = options.encodeBinary || encodeToBase58;
  return {
    encode: /* @__PURE__ */ __name((data) => encodeBinary(encodeData(data)), "encode")
  };
}
__name(makeJsonEncoder, "makeJsonEncoder");

// src/decoder.ts
import { decode as decodeBase58 } from "@urlpack/base58";
import { makeMessagePackDecoder } from "@urlpack/msgpack";
function makeJsonDecoder(options = {}) {
  const decodeString = options.decodeString || decodeBase58;
  const decodeBinary = options.decodeBinary || makeMessagePackDecoder().decode;
  return {
    decode: /* @__PURE__ */ __name((str) => decodeBinary(decodeString(str)), "decode")
  };
}
__name(makeJsonDecoder, "makeJsonDecoder");
export {
  makeJsonDecoder,
  makeJsonEncoder
};
/*! For license information please see index.mjs.LEGAL.txt */
//# sourceMappingURL=index.mjs.map
